import { getImageUrl } from '$global/utils/getImageUrl/getImageUrl';

type ImageRef = { filename_disk?: string | null } | null | undefined;

export const getJsonLdImages = (images: ImageRef[]) => [
	...new Set(
		images
			.map((image) => getImageUrl(image?.filename_disk, '1024px'))
			.filter(Boolean)
	),
];
